import { render, staticRenderFns } from "./OrderShippingUpdates.vue?vue&type=template&id=292d5448&scoped=true&"
import script from "./OrderShippingUpdates.vue?vue&type=script&lang=js&"
export * from "./OrderShippingUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292d5448",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292d5448')) {
      api.createRecord('292d5448', component.options)
    } else {
      api.reload('292d5448', component.options)
    }
    module.hot.accept("./OrderShippingUpdates.vue?vue&type=template&id=292d5448&scoped=true&", function () {
      api.rerender('292d5448', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/OrderShippingUpdates.vue"
export default component.exports